import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Autocomplete, Box, FormHelperText, TextField } from "@mui/material";
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useErrorHandler } from "../../hooks";
import HelmetReact from "../../Components/Helmet";
import "./style.css";
import useToggle from "../../hooks/use-toggle";
import { getPractitionersEmailAction } from "../../Redux/Actions/userAction";
import { useEffect } from "react";
import { AddExisitingUser } from "../../Redux/Actions/AuthActions";
import ReactLoading from "react-loading";

const AddExistingUser = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const [visiblePassword, setVisiblePassword] = useToggle(true);
  const [visibleConfirmPassword, setVisibleConfirmPassword] = useToggle(true);
  const { setMsgConfig } = useErrorHandler();
  const { doctorList } = useSelector((state) => state.User);
  const { loading } = useSelector((state) => state.Auth);
  const payload = {
    key: "",
  };
  useEffect(() => {
    dispatch(getPractitionersEmailAction(payload));
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      email: [],
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      email: yup
        .array()
        .of(
          yup
            .string()
            .email("Invalid email address")
            .required("Email is required")
        )
        .min(1, "At least one email address is required"),
    }),
    onSubmit: (values) => {
      let payload = {
        email: JSON.stringify(values.email),
      };
      
      if (!loading) {
        dispatch(AddExisitingUser(payload));
        setMsgConfig({
          alertOpen: true,
          message: "Registered successfully!",
          severity: "success",
          autoHideDuration: 2000,
        });
        setOpen(!open);
      }
    },
  });

  const handleOnChange = (event, option) => {
    formik.setFieldValue("email", option);
  };

  const handleClose = () => {
    setOpen(!open);
  };
  return (
    <>
      <HelmetReact name="Explore Category" />
      <Dialog open={open} onClose={handleClose} className="invite-modal">
        <DialogTitle>ADD EXISTING USER</DialogTitle>
        <DialogContent>
          <Box sx={{ my: 3 }}>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={doctorList?.map((option) => option?.email)}
              fullWidth
              onChange={handleOnChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Client Email"
                  placeholder="Client Email"
                  error={formik.touched.email && Boolean(formik.errors.email)}
                />
              )}
            />
            {formik.touched.email && formik.errors.email && (
              <FormHelperText className="error_message">
                {formik?.errors?.email?.includes("Invalid email address")
                  ? "Invalid email address"
                  : formik?.errors?.email}
              </FormHelperText>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button className="btn-dark" onClick={handleClose} variant="outlined">
            Cancel
          </Button>
          <Button
            className="btn-dark"
            variant="contained"
            onClick={formik.handleSubmit}
          >
            
            {loading ? (
              <ReactLoading
                type="spinningBubbles"
                height="30px"
                  width="30px"
                  color="#FFFFFF"                
              />
            ) : (
              "ADD"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddExistingUser;
